export default __webpack_public_path__ + "static/media/wordpress.60712ed4.svg";